import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const FlexBetSlipModalContainer: CSSObject = {
  bg: 'white',
  h: '100%',
  maxH: ['100dvh', null, '100%'],
};

export const FlexBetGroupContainer = (isKeypadVisible: boolean): CSSObject => ({
  // when copying this file for each theme, edit this value as necessary
  // depending on the difference between the keypad and betslip footer heights
  p: '1.5',
  mb: isKeypadVisible && 'unset',
});

export const BetSlipFooterContainer: CSSObject = {
  bg: 'alpha.200',
  color: 'alpha.700',
  '&&': {
    p: '3',
  },
};

export const EditBetsButton: CSSObject = {
  bg: 'none',
  color: 'beta.500',
  borderColor: 'beta.500',

  '&:hover, &:active': {
    bg: 'beta.500',
    color: 'white',
  },
};

export const BetSlipFooterRowTitle: CSSObject = {
  color: 'alpha.700',
  fontWeight: 'medium',
};

export const BetSlipFooterRowValue = (): CSSObject => ({
  color: 'alpha.700',
  fontWeight: 'bold',
});

export const buttonConfirmBetsProps: CustomButtonProps = {
  variant: 'solid',
};

export const buttonMakeDepositProps: CustomButtonProps = {
  variant: 'solid',
};

export const LowStakeDivider: CSSObject = {
  borderColor: 'blackAlpha.300',
  opacity: '1',
  borderStyle: 'dashed',
};

export const buttonClearBetsProps: CustomButtonProps = {
  h: '6',
  bg: 'alpha.700',
  borderRadius: 'full',
  fontWeight: 'bold',
  margin: 'auto',
  mt: '-23px',
  position: 'relative',
  lineHeight: 'normal',
  color: 'white',
  minW: '16',
  border: '3px solid',
  borderColor: 'white',
  px: '3',
  sx: {
    '.chakra-button__icon': {
      marginInlineEnd: '0.5',
    },
    '.chakra-icon': {
      boxSize: '3',
    },
    '&:hover, &:active': {
      bg: 'alpha.800',
    },
    '&&': {
      fontSize: '2xs',
    },
  },
};
